export const NOTIFICATION_CATEGORIES = {
    guildCreationApproved: 'GUILD_CREATION_APPROVED',
    guildCreationDenied: 'GUILD_CREATION_DENIED',
    guildUserInvitation: 'GUILD_USER_INVITATION',
    guildUserRemoved: 'USER_REMOVED_FROM_GUILD',
    serviceRequestCompleted: 'SERVICE_REQUEST_COMPLETED',
    serviceRequestQuotationUpdate: 'SERVICE_REQUEST_QUOTATION_UPDATE',
    serviceRequestCreated: 'SERVICE_REQUEST_CREATED',
}
